/**
 * /devhub/ai-chat — AI Chat (operator). Surface Layer (/01). REQ-001.91 §1.5 / §B1.
 *
 * Rebuilt over the REAL `@carbon/ai-chat` `ChatContainer` (via the `AiChatHost` wrapper) — NOT the
 * old custom dark-box `RagChatThread`. Fixes the three root causes from the rebuild spec:
 *   (1) raw-JSON render — `customLoadHistory` → `loadAiChatHistory()` already normalizes
 *       `action_results.output_json` (no `{"response_type":…}` literal); the answer maps to a Carbon
 *       TEXT / USER_DEFINED response, never raw JSON.
 *   (2) guardrail verdict — the worker's terminal status is the single source; ungrounded answers are
 *       held (needs_human_review, fail-closed), never an "Answered" + "awaiting verification" mix.
 *   (3) layout — the genuine `ChatContainer`, not generic boxes.
 *
 * BINDING INVARIANTS: the browser ONLY enqueues + polls — send → `rag.chat_request` ActionFrame
 * (authed, RLS, correlated by `client_frame_id`) → the local Granite worker drains on-device →
 * writes `action_results.output_json` → the surface reads it back. The browser NEVER calls a model,
 * never escalates to paid, never writes directly; `paid_model_called=false`. Transport reused verbatim
 * from `@lib/platform-sdk` (`submitAiChatMessage`/`pollAiChatAnswer`/`loadAiChatHistory`) via the
 * sample — no new BFF route, no worker change.
 *
 * Carbon MCP evidence: `ChatContainer`/`PublicConfig`/`BusEventType` (`@carbon/ai-chat ^1.14.0`,
 * verified installed + used by `chat.tsx`); `AILabel` via `AiAffordanceLabel`. g100, zero inline
 * styles. Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';

import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';
import { AiAffordanceLabel } from '../components/devhub-kit/AiAffordanceLabel';
import { AiChatHost } from '@/sample-carbon/ai-chat';

export const Route = createFileRoute('/devhub/ai-chat')({ component: AiChatPage });

function AiChatPage() {
  return (
    <DevHubPanelPage
      title="AI Chat"
      subtitle="Ask the local Granite worker. The browser only enqueues a rag.chat_request — it never calls a model. Grounded answers render as text + sources; ungrounded answers are held for human review."
      status={{ label: 'local Granite · enqueue + poll', live: true }}
      actions={<AiAffordanceLabel />}
    >
      <AiChatHost />
    </DevHubPanelPage>
  );
}
